import classNames from 'classnames'
import styles from '../CompanyRegistration.module.scss'

type Step = {
  label: string
  testId: string
}

type Props = {
  currentStep: 1 | 2
  isStep2Clickable: boolean
  onStep1Click: () => void
  onStep2Click: () => void
  steps: [Step, Step]
}

export function StepIndicator({
  currentStep,
  isStep2Clickable,
  onStep1Click,
  onStep2Click,
  steps,
}: Props) {
  const [step1, step2] = steps

  return (
    <div className={styles.companyRegistration__stepIndicator}>
      <div
        className={classNames(
          styles.companyRegistration__stepItem,
          currentStep === 1
            ? styles['companyRegistration__stepItem--active']
            : styles['companyRegistration__stepItem--completed'],
        )}
        onClick={currentStep !== 1 ? onStep1Click : undefined}
        style={{ cursor: currentStep !== 1 ? 'pointer' : 'default' }}
        data-testid={step1.testId}
      >
        <div className={styles.companyRegistration__stepNumber}>1</div>
        <div className={styles.companyRegistration__stepLabel}>
          {step1.label}
        </div>
      </div>

      <div className={styles.companyRegistration__stepDivider} />

      <div
        className={classNames(
          styles.companyRegistration__stepItem,
          currentStep === 2 && styles['companyRegistration__stepItem--active'],
        )}
        onClick={
          currentStep !== 2 && isStep2Clickable ? onStep2Click : undefined
        }
        style={{
          cursor: currentStep !== 2 && isStep2Clickable ? 'pointer' : 'default',
        }}
        data-testid={step2.testId}
      >
        <div className={styles.companyRegistration__stepNumber}>2</div>
        <div className={styles.companyRegistration__stepLabel}>
          {step2.label}
        </div>
      </div>
    </div>
  )
}
